import React, { Component } from 'react';
import { observable, action, runInAction, computed } from 'mobx';
import { observer } from 'mobx-react';
import { Link } from '@reach/router';
import { keys } from 'lodash';

import { makeRequest, errorResponse } from 'js/services/Network';
import { lightGrey3Color } from 'js/config/style';

import { transactionDescriptionTranslation } from 'js/stores/pages/AdminDashboardPage/TransactionStore';

import LoadingSpinner from '../../LoadingSpinner';
import Container from './Container';
import Title from './Title';
import Content from './Content';
import Display from './Display';
import Label from './Label';
import Image from './Image';
import LogoIcon from './LogoIcon';

@observer
export default class Transaction extends Component {
  constructor(props) {
    super(props);
    this.load(props.load);
  }

  @observable error = null;
  @observable isLoading = true;
  @observable.ref data = null;

  @computed get description() {
    return this.data ? transactionDescriptionTranslation[this.data.description] : '';
  }

  hasLoadProps = () =>
    keys(this.props.load || {}).reduce((hasLoadProps, prop) => hasLoadProps && !!this.props.load[prop], true);

  @action async load({ transaction_id: id }) {
    if (this.hasLoadProps()) {
      this.isLoading = true;
      this.error = null;

      try {
        const data = (await makeRequest('admin-transaction-data', { id })).data;
        runInAction(() => (this.data = data));
      } catch (error) {
        runInAction(() => (this.error = errorResponse(error)));
      }

      runInAction(() => (this.isLoading = false));
    } else {
      this.error = 'Could not load transaction';
      this.isLoading = false;
    }
  }

  render() {
    const data = this.data;

    return (
      <Container mode={this.isLoading ? 'loading' : this.error ? 'error' : 'display'}>
        {this.isLoading ? (
          <LoadingSpinner padding="1rem" />
        ) : this.error ? (
          <>
            <Display>
              <LogoIcon name="institution" color={lightGrey3Color} />
            </Display>
            <Title>{this.props.title || 'Bank account'}</Title>
            <Content>{this.error}</Content>
          </>
        ) : (
          <>
            <Display>
              <Image logo={data.logo} logo_type={data.logo_type} />
            </Display>
            <Title>
              <Link to={`/admin/transactions/transaction/${data.id}`}>{this.props.title || 'Transaction'}</Link>
            </Title>
            <Content>
              {data.creator_email && (
                <>
                  <Label>Created by</Label>
                  <div>{data.creator_name}</div>
                </>
              )}

              <Label>Date</Label>
              <div>{data.created_at}</div>

              <Label>Description</Label>
              <div>{this.description}</div>
            </Content>
          </>
        )}
      </Container>
    );
  }
}
